var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 21C1.45 21 0.979333 20.8043 0.588 20.413C0.196 20.021 0 19.55 0 19V7C0 6.45 0.196 5.97933 0.588 5.588C0.979333 5.196 1.45 5 2 5H12.1C12.0333 5.33333 12 5.66667 12 6C12 6.33333 12.0333 6.66667 12.1 7H2V19H18V10.9C18.3833 10.8167 18.7417 10.7 19.075 10.55C19.4083 10.4 19.7167 10.2167 20 10V19C20 19.55 19.8043 20.021 19.413 20.413C19.021 20.8043 18.55 21 18 21H2ZM2 7V19V7ZM17 9C16.1667 9 15.4583 8.70833 14.875 8.125C14.2917 7.54167 14 6.83333 14 6C14 5.16667 14.2917 4.45833 14.875 3.875C15.4583 3.29167 16.1667 3 17 3C17.8333 3 18.5417 3.29167 19.125 3.875C19.7083 4.45833 20 5.16667 20 6C20 6.83333 19.7083 7.54167 19.125 8.125C18.5417 8.70833 17.8333 9 17 9ZM10 12L13.65 9.725C13.8833 9.94167 14.1377 10.129 14.413 10.287C14.6877 10.4457 14.975 10.5833 15.275 10.7L10.525 13.675C10.3583 13.775 10.1833 13.825 10 13.825C9.81667 13.825 9.64167 13.775 9.475 13.675L2 9V7L10 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.ef1cfbd708119bf7ccd4f82c8a4634a9.svg";
export { ForwardRef as ReactComponent };